import { render, staticRenderFns } from "./projectteam.vue?vue&type=template&id=0090d79d&scoped=true&"
import script from "./projectteam.vue?vue&type=script&lang=js&"
export * from "./projectteam.vue?vue&type=script&lang=js&"
import style0 from "./projectteam.vue?vue&type=style&index=0&id=0090d79d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090d79d",
  null
  
)

export default component.exports